import $ from 'jquery';
import AOS from 'aos';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SplitText } from 'gsap/SplitText';
//import { Fancybox } from '@fancyapps/ui';
import { Carousel } from '@fancyapps/ui/dist/carousel/';
import { Autoplay } from '@fancyapps/ui/dist/carousel/carousel.autoplay.js';


$(function(){
    AOS.init({
        duration: 1000,
        once: false,
        offset: 120,
    });

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
    window.ScrollTrigger = ScrollTrigger;

    window.smoother = ScrollSmoother.create({
        wrapper: '#smooth-wrapper',
        content: '#smooth-content',
        smooth: 1.1,
        smoothTouch: 0.1,
        effects: true,
    });

    $(document).on('click', 'a[href*="#"]', function (event) {
        const href = $(this).attr('href');

        if (!href || href === '#') {
            return;
        }

        let url;

        try {
            url = new URL(href, window.location.href);
        } catch (error) {
            return;
        }

        if (!url.hash) {
            return;
        }

        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
            return;
        }

        const target = document.querySelector(url.hash);

        if (!target) {
            return;
        }

        event.preventDefault();

        if (window.smoother) {
            gsap.to(window.smoother, {
                scrollTop: window.smoother.offset(target, 'top top'),
                duration: 1.6,
                ease: 'power2.out',
                overwrite: 'auto',
            });
            return;
        }

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    });

    $(window).off('scroll.header').on('scroll.header', function () {
        if ($(window).scrollTop() > 100) {
            $('nav.main-nav').addClass('opaque');
        } else {
            $('nav.main-nav').removeClass('opaque');
        }
    });


    let carousels = document.querySelectorAll(".f-carousel");
    for (let carousel of carousels) {
        const slidesPerPage = parseInt(carousel.dataset?.slidesperpage ?? "1", 10) || 1;

        carousel.style.setProperty("--f-carousel-slide-width", `calc(100% / ${slidesPerPage})`);

        let carouselPlugins = carousel.classList.contains('f-carousel-not-autoplay') ? { } : { Autoplay };
        Carousel(carousel, {
            slidesPerPage,
            infinite: !carousel.classList.contains('f-carousel-not-infinite'),
            fill: true,
            adaptiveHeight: true,
            Dots: {
                maxCount: 2
            },
            Autoplay: {
                timeout: 2000,
                showProgress: false
            },
            Navigation: {
                nextTpl: "<svg id=\"text_gràfica\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53.57 53.57\"><circle class=\"circle\" cx=\"26.78\" cy=\"26.78\" r=\"26.78\"/><line class=\"line\" x1=\"12.21\" y1=\"27.38\" x2=\"40.27\" y2=\"26.23\"/><polygon class=\"polygon\" points=\"37.13 30.45 36.42 29.75 39.89 26.25 36.14 23.04 36.8 22.28 41.36 26.19 37.13 30.45\"/></svg>",
                prevTpl: "<svg id=\"text_gràfica\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53.57 53.57\"><circle class=\"circle\" cx=\"26.78\" cy=\"26.78\" r=\"26.78\"/><line class=\"line\" x1=\"41.86\" y1=\"26.69\" x2=\"13.79\" y2=\"27.83\"/><polygon class=\"polygon\" points=\"16.94 23.61 17.65 24.32 14.18 27.82 17.92 31.03 17.27 31.78 12.71 27.88 16.94 23.61\"/></svg>",
            },
        }, carouselPlugins).init();
    }

    $(".js-punts-partida-more").on("click", function () {
        const $button = $(this);
        const $section = $button.closest(".page-section");
        const total = parseInt($button.data("total-batches"), 10);
        const current = parseInt($button.data("current-batch"), 10);
        const next = (current + 1) % total;

        const $nextBatch = $section.find(".js-punts-partida-batch[data-batch-index='" + next + "']");
        const $items = $nextBatch.find(".steps-2-item[data-aos]");

        $section.find(".js-punts-partida-batch[data-batch-index='" + current + "']").addClass("d-none");

        $items.removeClass("aos-animate");
        $nextBatch.removeClass("d-none");

        // force a reflow so the reset above is applied before re-triggering the animation
        void $nextBatch[0].offsetWidth;
        requestAnimationFrame(function () {
            $items.addClass("aos-animate");
        });

        $button.data("current-batch", next);
    });

    $(".js-punts-partida-hover").on("mouseenter", function () {
        const bg = $(this).data("bg");
        if (!bg) {
            return;
        }

        $(this).closest(".page-section").find(".js-punts-partida-hover-bg")
            .css("--hover-bg-image", "url(" + bg + ")")
            .addClass("is-visible");
    }).on("mouseleave", function () {
        $(this).closest(".page-section").find(".js-punts-partida-hover-bg").removeClass("is-visible");
    });

    for (let splitElement of $("[data-split]")) {
        var split = new SplitText(splitElement, {type: "chars,words,lines"});
        gsap.from(split.words, {
            duration: $(splitElement).data("split-duration") ?? .25,
            delay: $(splitElement).data("split-delay") ?? 0,
            y: $(splitElement).data("split-y") ?? 80,
            autoAlpha: 0,
            stagger: 0.05
        });
    }
});
